import Internal from 'common/modules/internal'
import { paymentMethods } from 'common/modules/selectors'

import { types as lifecycleTypes, creators } from '../../actions'

export default {
    [lifecycleTypes.PAYMENT_METHOD_ADDED]: [
        {
            event: 'pico.paymentMethod.added',
            data() {
                return { detail: 'New payment method added' }
            },
        },
    ],
}

let initialPaymentMethods = null

export const checkPaymentMethodAdded = () => ({ state, dispatch }) => {
    const currentPaymentMethods = paymentMethods(state)
    if (initialPaymentMethods === null) {
        initialPaymentMethods = currentPaymentMethods
    }

    if (initialPaymentMethods.length < currentPaymentMethods.length) {
        dispatch(Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                ...(creators.paymentMethodAdded()),
            },
        }))
        initialPaymentMethods = currentPaymentMethods
    }
}
